export interface Iconstant {
    ApiUrl: string;
    TemplateUrl: string;
    Type: string
    errSrc: {
        product: string;
        vendor: string;
        category: string;
        productType: string;
        brand: string;
        manufacturer: string;
    }
}

export var constant: Iconstant = {
    "ApiUrl": "/DesktopModules/ECBVendorStore/ECBVendorWebApi/API/",
    "TemplateUrl": "/DesktopModules/ECBVendorStore/ECBVendorView/template/",
    "Type": "webmark",
    errSrc: {
        product: 'https://s3.bazaryab.com/Images/Default/No-Image-600x600.jpg',
        vendor: 'https://s3.bazaryab.com/Images/Default/No-ShopLogo-600x600.jpg',
        category: 'https://s3.bazaryab.com/Images/Default/No-Image-600x600.jpg',
        productType: 'https://s3.bazaryab.com/Images/Default/No-Image-600x600.jpg',
        brand: 'https://s3.bazaryab.com/Images/Default/No-Image-600x600.jpg',
        manufacturer: 'https://s3.bazaryab.com/Images/Default/No-Image-600x600.jpg'
    }
}
if (location.host == "www.bazaryab.com" || location.host == "bazaryab.dev" || location.host == "bazaryab-9.dev" || location.host == "www.demo.bazaryab.com" || location.host == "localhost:3000" || location.host == "192.168.2.70:3000") {
    constant.Type = "bazaryab"
    constant.ApiUrl = "/DesktopModules/ECBMainStore/ECBMainWebApi/API/"
    constant.TemplateUrl = "/DesktopModules/ECBMainStore/ECBMainView/template/"
}


// WEBPACK FOOTER //
// ./src/store-modules/app/ecb.constant.ts